import type { TemplateAssociations } from "@amzn/d16-g-cdb-publisher-portal-typescript-client";
import type { AsyncState, UseAsyncActions } from "@react-hookz/web";
import { useAsync } from "@react-hookz/web";

import { getCdbApiClient } from "../../api/cdbApi/cdbApi";
import { getPublisherPortalApiClient } from "../../api/publisherPortalApi/publisherPortalApi";
import { isAccountAgnosticId } from "../../utils/permission.utils";
import { isTemplateInScope } from "../../utils/publisherPortal.utils";
import { useAsyncErrorStatusNotification } from "../notifications/useAsyncErrorStatusNotification";

export function useOnDemandInsightsAction(
    advertiserId?: string,
    theme?: string,
): [
    AsyncState<TemplateAssociations[]>,
    UseAsyncActions<TemplateAssociations[]>,
] {
    const [onDemandInsightsState, onDemandInsightsAction] =
        useAsync(async () => {
            const { data: templates = [] } = await (
                await getPublisherPortalApiClient()
            ).getTemplatesWithAssociations({});

            if (isAccountAgnosticId()) {
                return templates.filter((t) =>
                    isTemplateInScope(t, [], theme, true),
                );
            }
            const { data: inputSources = [] } = await (
                await getCdbApiClient()
            ).getInputSourcesByAdvertiserId({
                advertiserId,
            });

            const templatesInScope = templates.filter((t) =>
                isTemplateInScope(t, inputSources, theme, false),
            );

            return templatesInScope;
        }, []);
    useAsyncErrorStatusNotification(onDemandInsightsState);

    return [onDemandInsightsState, onDemandInsightsAction];
}
